import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/',
      component: () => import('../components/Home.vue'),
      meta: {
        title: '自述文件'
      },
      children: [{
          path: '/dashboard',
          component: () => import('../pages/Index/Index.vue'),
          meta: {
            title: '首页'
          }
        },
        {
          path: '/supplyAdd',
          component: () => import('../pages/Supply/Supplyadd.vue'),
          meta: {
            title: '商品管理 - 添加供应'
          }
        },
        {
          path: '/supplyManage',
          component: () => import('../pages/Supply/Supplymanage.vue'),
          meta: {
            title: '商品管理 - 供应管理'
          }
        },
        {
          path: '/supplyDrafts',
          component: () => import('../pages/Supply/Supplydrafts.vue'),
          meta: {
            title: '商品管理 - 草稿箱'
          }
        },
        {
          path: '/supplyVideo',
          component: () => import('../pages/Supply/Supplyvideo.vue'),
          meta: {
            title: '商品管理 - 视频库'
          }
        },
        {
          path: '/supplyImages',
          component: () => import('../pages/Supply/Supplyimages.vue'),
          meta: {
            title: '商品管理 - 相册管理'
          }
        },
        {
          path: '/baiduCard',
          component: () => import('../pages/Supply/Supplycard.vue'),
          meta: {
            title: '商品管理 - 百度名片'
          }
        },
        {
          path: '/supplyCate',
          component: () => import('../pages/Supply/Supplycate.vue'),
          meta: {
            title: '商品管理 - 供应橱窗'
          }
        },
        {
          path: '/repeatSupply',
          component: () => import('../pages/Supply/repeatSupply.vue'),
          meta: {
            title: '商品整改中心 - 重复商品'
          }
        },
   
        {
          path: '/lowqualitySupply',
          component: () => import('../pages/Supply/lowqualitySupply.vue'),
          meta: {
            title: '商品整改中心 - 低质商品'
          }
        },
        {
          path: '/newsAdd',
          component: () => import('../pages/News/Newsadd.vue'),
          meta: {
            title: '企业资讯 - 发布资讯'
          }
        },
        {
          path: '/newsEdit',
          component: () => import('../pages/News/Newsedit.vue'),
          meta: {
            title: '企业资讯 - 编辑资讯'
          }
        },
        {
          path: '/newsManage',
          component: () => import('../pages/News/Newsmanage.vue'),
          meta: {
            title: '企业资讯 - 资讯管理'
          }
        },
        {
          path: '/shopBuild',
          component: () => import('../pages/Shop/Shopbuild.vue'),
          meta: {
            title: '店铺管理 - 店铺装修'
          }
        },
        {
          path: '/shopCustom',
          component: () => import('../pages/Shop/Shopcustom.vue'),
          meta: {
            title: '店铺管理 - 自定义店铺'
          }
        },
        {
          path: '/shopBanner',
          component: () => import('../pages/Shop/Shopbanner.vue'),
          meta: {
            title: '店铺管理 - 店铺banner'
          }
        },
        {
          path: '/shopMove',
          component: () => import('../pages/Shop/Shopmove.vue'),
          meta: {
            title: '店铺管理 - 一键搬家'
          }
        },
        {
          path: '/shopMovelist',
          component: () => import('../pages/Shop/Shopmovelist.vue'),
          meta: {
            title: '店铺管理 - 搬家记录'
          }
        },
        {
          path: '/prodsBanner',
          component: () => import('../pages/Shop/prodsBanner.vue'),
          meta: {
            title: '店铺管理 - 实地banner'
          }
        },
        {
          path: '/vipAccount',
          component: () => import('../pages/Vip/Vipinfo.vue'),
          meta: {
            title: '账号管理 - 会员资料'
          }
        },
        {
          path: '/vipCompany',
          component: () => import('../pages/Vip/Vipcompany.vue'),
          meta: {
            title: '账号管理 - 公司资料'
          }
        },
        {
          path: '/vipLevel',
          component: () => import('../pages/Vip/Viplevel.vue'),
          meta: {
            title: '账号管理 - 升级续费'
          }
        },
        {
          path: '/change_password',
          component: () => import('../pages/Login/changePassword.vue'),
          meta: {
            title: '账号管理 - 修改密码'
          }
        },
        {
          path: '/baiduUnion',
          component: () => import('../pages/Popular/Baidunion.vue'),
          meta: {
            title: '推广管理 - 百度联盟号'
          }
        },
        {
          path: '/aicaigouFlow',
          component: () => import('../pages/Popular/Aicaigouflow.vue'),
          meta: {
            title: '推广管理 - 爱采购流量统计'
          }
        },
        {
          path: '/aicaigouPage',
          component: () => import('../pages/Popular/Aicaigoupage.vue'),
          meta: {
            title: '推广管理 - 爱采购数据'
          }
        },
        {
          path: '/aicaigouMonth',
          component: () => import('../pages/Popular/AicaigouMonth.vue'),
          meta: {
            title: '推广管理 - 爱采购月报'
          }
        },
        {
          path: '/cloudAddOnline',
          component: () => import('../pages/Cloud/Cloudadd.vue'),
          meta: {
            title: '材云发 - 添加云发'
          }
        },
        {
          path: '/cloudEditOnline',
          component: () => import('../pages/Cloud/Cloudedit.vue'),
          meta: {
            title: '材云发 - 编辑云发'
          }
        },
        {
          path: '/cloudOnlineList',
          component: () => import('../pages/Cloud/Cloudlist.vue'),
          meta: {
            title: '材云发 - 云发列表'
          }
        },
        {
          path: '/notification',
          component: () => import('../pages/Notice/Notice.vue'),
          meta: {
            title: '通知中心'
          }
        },
        {
          path: '/baiduAskData',
          component: () => import('../pages/Answer/Answerdata.vue'),
          meta: {
            title: '爱采购问答 - 问答数据'
          }
        },
        {
          path: '/baiduAskList',
          component: () => import('../pages/Answer/Answerlist.vue'),
          meta: {
            title: '爱采购问答 - 问答列表'
          }
        },
        {
          path: '/app',
          component: () => import('../pages/App/App.vue'),
          meta: {
            title: '爱采购App下载'
          }
        },
        {
          path: '/404',
          component: () => import('../components/404.vue'),
          meta: {
            title: '404'
          }
        },
      ]
    },
    {
      path: '/login',
      component: () => import('../pages/Login/Login.vue'),
      meta: {
        title: '登录'
      }
    },
    {
      path: '/register',
      component: () => import('../pages/Login/Register.vue'),
      meta: {
        title: '注册'
      }
    },
    {
      path: '/forget',
      component: () => import('../pages/Login/Forget.vue'),
      meta: {
        title: '忘记密码'
      }
    },
    {
      path: '/personalCenter',
      component: () => import('../pages/Login/Personal.vue'),
      meta: {
        title: '个人中心'
      }
    },
    {
      path: '/pictureList',
      component: () => import('../pages/Supply/Supplyimagelist.vue'),
      meta: {
        title: '相册内页'
      }
    },
    {
      path: '/supplydetail',
      component: () => import('../pages/Supply/Supplydetail.vue'),
      meta: {
        title: '商品详情'
      }
    },
    {
      path: '/repeatdetail',
      component: () => import('../pages/Supply/Repeatdetail.vue'),
      meta: {
        title: '低质重复详情'
      }
    },
    {
      path: '/repeat',
      component: () => import('../pages/Supply/repeat.vue'),
      meta: {
        title: '重复商品列表'
      }
    },
    {
      path: '/draftsDetail',
      component: () => import('../pages/Supply/Supplydetaildrafts.vue'),
      meta: {
        title: '草稿详情'
      }
    },
    {
      path: '/supplyvideodetail',
      component: () => import('../pages/Supply/Supplyvideodetail.vue'),
      meta: {
        title: '视频详情'
      }
    },
    {
      path: '/supplyvideoadd',
      component: () => import('../pages/Supply/Supplyvideoadd.vue'),
      meta: {
        title: '批量绑定供应'
      }
    },
    {
      path: '/supplyvideoedit',
      component: () => import('../pages/Supply/Supplyvideoedit.vue'),
      meta: {
        title: '编辑视频'
      }
    },
    {
      path: '/newsDetail',
      component: () => import('../pages/News/Newsdetail.vue'),
      meta: {
        title: '资讯详情'
      }
    },
    {
      path: '/shopbannerdetail',
      component: () => import('../pages/shop/Shopbannerdetail.vue'),
      meta: {
        title: '广告位详情'
      }
    },
    {
      path: '/shopbanneredit',
      component: () => import('../pages/shop/Shopbanneredit.vue'),
      meta: {
        title: '编辑广告位'
      }
    },
    {
      path: '/shopListdetail',
      component: () => import('../pages/shop/Shoplistdetail.vue'),
      meta: {
        title: '搬家详情'
      }
    },
    {
      path: '/supplyCopy',
      component: () => import('../pages/Supply/Supplycopy.vue'),
      meta: {
        title: '编辑供应'
      }
    },
    {
      path: '/editDrafts',
      component: () => import('../pages/Supply/Supplydraftsedit.vue'),
      meta: {
        title: '编辑草稿'
      }
    },
    {
      path: '/cloudDetail',
      component: () => import('../pages/Cloud/Clouddetail.vue'),
      meta: {
        title: '云发详情'
      }
    },
    {
      path: '/noticeDetail',
      component: () => import('../pages/Notice/Noticedetail.vue'),
      meta: {
        title: '通知中心详情'
      }
    },
    {
      path: '/askDetail',
      component: () => import('../pages/Answer/Askdetail.vue'),
      meta: {
        title: '问答详情'
      }
    },
    {
      path: '/ask',
      component: () => import('../pages/Answer/Ask.vue'),
      meta: {
        title: '去回答'
      }
    },
    {
      path: '/aicaigouDetail',
      component: () => import('../pages/Popular/Aicaigoudetail.vue'),
      meta: {
        title: '爱采购数据'
      }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js